import { Injectable, isDevMode, inject } from '@angular/core';
import { DataLoader } from './data.loader';
import { AdminUserMenuControl, UserMenuGroup, UserMenuItem } from '../models/admin-user-menu/user-menu-control.model';
import { ApiService } from './api.service';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root',
})
export class UserMenuService {
  private apiService = inject(ApiService);
  private loginService = inject(LoginService);
  private dataLoader = inject(DataLoader);


  private getLoginUserMenuControl(): AdminUserMenuControl {
    let loginUserId = this.apiService.getUserToken().UserId;

    return this.dataLoader.getRequiredData().AdminUserMenusControl.find(control => control.UserId === loginUserId);
  }

  getLoginUserMenuGroups(): UserMenuGroup[] {
    let userMenuControl: AdminUserMenuControl = this.getLoginUserMenuControl();
    let allUserMenuGroups: UserMenuGroup[] = this.dataLoader.getRequiredData().UserMenuGroups;
    let result: UserMenuGroup[] = [];

    if (!userMenuControl || !userMenuControl.Menus) {
      return result;
    }

    for (let group of allUserMenuGroups) {
      let matchingItems: UserMenuItem[] = [];

      for (let item of group.Items) {
        if (userMenuControl.Menus.includes(item.ItemCode) && (isDevMode() || !item.DevModeOnly)) {
          matchingItems.push(item);
        }
      }

      if (matchingItems.length > 0) {
        result.push({
          GroupName: group.GroupName,
          Code: group.Code,
          DevModeOnly: group.DevModeOnly,
          Items: matchingItems,
        });
      }
    }

    return result;
  }
}
